import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import type { ConnectedProps } from 'react-redux';
import { useTranslation } from '@lt/localization';

import { getPartnerPromoTitle } from 'src/store/menu/selectors';

const HEADER_PROMO_CLASSNAME = 'header_promo';
const HEADER_PROMO_TITLE = 'header_promo-title';
const HEADER_PROMO_TEXT = 'header_promo-text';

const WLHeaderDescription = ({ partnerPromoTitle }) => {
  const { t } = useTranslation();

  return partnerPromoTitle ? (
    <CustomDescription
      dangerouslySetInnerHTML={{ __html: partnerPromoTitle }}
    />
  ) : (
    <CustomDescription className={HEADER_PROMO_CLASSNAME}>
      <div className={HEADER_PROMO_TITLE}>{t('homeHeader.promoTitle')}</div>
      <div className={HEADER_PROMO_TEXT}>{t('homeHeader.promoText')}</div>
    </CustomDescription>
  );
};

const CustomDescription = styled.div`
  background: none !important;
  color: #fff;
  width: 100%;
  z-index: 15;
  height: 100%;
  position: relative;
  text-align: center;
  text-shadow: 0 0 10px #919499;
  padding: 10px 25px 0;
  margin-bottom: -100px; // хак, чтобы не менять высоту обертки сиги

  & .${HEADER_PROMO_TITLE} {
    font-size: 50px;
    font-weight: bold;
  }

  & .${HEADER_PROMO_TEXT} {
    font-size: 24px;
    white-space: pre-line;
  }
`;

const mapStateToProps = (state) => ({
  partnerPromoTitle: getPartnerPromoTitle(state),
});

const connector = connect(mapStateToProps);
export type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(WLHeaderDescription);
